import { useEffect, useLayoutEffect } from 'react';

/**
 * React hook: useLayoutEffect on client, useEffect on server.
 * Prevents SSR warnings.
 * @example
 * useIsomorphicLayoutEffect(() => { ... }, []);
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
